import React from 'react';
import { SimpleFlexbox, Text, LoadingSpinner } from 'ctm-components';
import styles from './shielded.css';

/**
 * the Loading element
 * @returns {Node} FormLoading component
 */
const FormLoading = () => (
    <SimpleFlexbox display="flex" column>
        <div className={styles.loading}>
            <LoadingSpinner />
        </div>
        <Text tagName="h2" className={styles.center}>
            Sending Your information to Shielded Insurance
        </Text>
    </SimpleFlexbox>
);

export { FormLoading };
